/**
 * Régua única do prazo D-n (E50.F6 — FR-REQ-05).
 *
 * Compartilhada pela esteira do perito (EsteiraPortal) e pela tela de
 * resultado do portal (T2): dias corridos até o prazo, teto do dia.
 * `D-n` restando; valor negativo = estourado (`D+n`, tinta de perigo
 * sinalizada SOBRE o estado corrente — o estado não muda).
 */
export function diasAtePrazo(slaDueAtIso: string, agora: Date): number {
  const due = new Date(slaDueAtIso).getTime();
  return Math.ceil((due - agora.getTime()) / 86_400_000);
}

export function rotuloPrazo(slaDueAtIso: string, agora: Date): string {
  const dias = diasAtePrazo(slaDueAtIso, agora);
  return dias < 0 ? `D+${Math.abs(dias)}` : `D-${dias}`;
}
